import classNames from 'classnames'
import { jsonConvert } from '../../../../helpers/jsonConvert'
import { AnswerButton } from '../AnswerButton/AnswerButton'
import { useTaskHomeWork } from '../hooks/useTaskHomeWork'
import s from './Missing.module.css'
import { formateTime } from '@/helpers/formateTime'
import Constructor from '@UI/New/Constructor'
import { Fragment, useRef } from 'react'
import JsonPars from '@UI/JsonPars/JsonPars'
import { useVideoState } from '../hooks/useVideoState'
import { VideoAnswer } from '../VideoAnswer/VideoAnswer'
import { DynamicInput } from '@UI/New/DynamicInput'

export const Missing = ({ type,  ...props }) => {
  switch (type) {
    case 'decided': return <Decided {...props} />
    case 'correction': return <Correction {...props} />
    default: return <Task hist={props?.hist}  {...props} />
  }
}

const Correction = ({ answer_options, correct_answer }) => {
  return <div className={s.answerContainer}>
    <p className={classNames(s.text, s.textCorrection)}>
      {answer_options?.map((el, i) => {
        if (el.answer === 1) {
          const correctAnswer = correct_answer[i]
          const answerText = !correctAnswer?.type ? correctAnswer?.text ?? '' : '';

          return <Fragment key={i}>
              {
                    el?.fromNewLine == '1' && (
                      <div style={{width:'100%', height: '0'}}></div>
                    )
              }
              <div className={s.itemWrapper}>
                <div className={s.questionWrapper}><JsonPars json={el.question} /></div>
                {
                  el.type === 'constructor' && (
                      <Constructor 
                        className={(classNames(s.constructorCorrection, s.constructorCorrectionInlineDisplay))}
                        value={[]}
                        prohibitEditing
                      />
                  )
                }
                {
                  el.type !== 'constructor' && (
                    <DynamicInput
                      targetWord={answerText}
                      
                      className={classNames(s.booble, s.input)} 
                      disabled={true} 
                      placeholder='Напишите ответ'
                    />
                  )
                }
              </div>
          </Fragment>
        }
        return <Fragment key={i}>
          {
            el?.fromNewLine == '1' && (
              <div style={{width:'100%', height: '0'}}></div>
            )
          }
          <div className={s.itemWrapper}>
              <div className={s.questionWrapper}><JsonPars json={el.question} /></div>
          </div>
        </Fragment>
      })}
    </p>
  </div >
}

const Decided = ({ userRole, ...props }) => {
  const { video, videoType } = useVideoState(
              {
                  video_source_type: props?.params?.result?.video_source_type,
                  video_solution: props?.params?.result?.video_solution,
                  video_solution_platform_media: props?.params?.result?.video_solution_platform_media,
                  video_solution_iframe: props?.params?.result?.video_solution_iframe
              }
  );
  const answer = jsonConvert(props?.params?.result?.answer, 'json')
  const correctAnswer = jsonConvert(props?.params?.result?.correct_answer, 'json')
  return <div className={s.answerContainer}>
    <p className={s.text}>
      {props?.answer_options?.map((el, i) => {
        
        if (el?.answer === 1) {
          const isConstructor = el.type === 'constructor';
          // const arrayСorrectAnswersWithoutIds = isConstructor ? correctAnswer[i]?.text.map(({ id, ...rest }) => rest) : [];
          // const arrayAnswersWithoutIds = isConstructor ? answer[i]?.text.map(({ id, ...rest }) => rest) : [];

          // const properly = isConstructor ? 
          //                     jsonConvert(arrayСorrectAnswersWithoutIds) === jsonConvert(arrayAnswersWithoutIds) : correctAnswer[i]?.text === answer[i]?.text;
          const isCorrect = !props?.hideSolutionCorrectness ? (isConstructor ? answer[i]?.is_correct : correctAnswer[i]?.text === answer[i]?.text) : true;
          return (
            <Fragment key={i}>
              {
                    el?.fromNewLine == '1' && (
                      <div style={{width:'100%', height: '0'}}></div>
                    )
              }
              <div className={s.itemWrapper}>
                <div className={s.questionWrapper}><JsonPars json={el.question} /></div>
                {
                  !isConstructor && (
                    <span className={classNames(s.booble, s.boobleFc, { [s.accent]: isCorrect }, { [s.red]: !isCorrect })}>
                        {i + 1} {answer[i]?.text}  
                      </span>
                  )
                }
                {
                  isConstructor && (
                      <span className={classNames(s.booble, s.boobleConstructor, { [s.accent]: isCorrect }, 
                                                                                  { [s.red]: !isCorrect })}>
                        {i + 1} <Constructor 
                                    value={(answer[i]?.text && Array.isArray(answer[i]?.text)) ? answer[i]?.text : []}
                                    prohibitEditing
                                    className={(classNames(s.constructorCorrection, s.constructorAnswers))}/> 
                      </span>
                  )
                }

              </div>
            </Fragment>
          )
        }
        return <Fragment key={i}>
            {
              el?.fromNewLine == '1' && (
                <div style={{width:'100%', height: '0'}}></div>
              )
            }
            <div className={s.itemWrapper}>
                <div className={s.questionWrapper}><JsonPars json={el.question} /></div>
            </div>
        </Fragment>
      })}
    </p>
    {
      !props?.hideSolutionCorrectness && (
        <div className={s.answerWrap}>
          <span className={classNames(s.capsuleLeft)}>Правильные ответы</span>
          {correctAnswer.length > 0 && correctAnswer?.map((el, i) => {
            return (
              <>
                {
                  el.type === 'constructor' && <div style={{display: 'flex', gap: '5px'}}>
                    {i + 1})
                    <Constructor 
                      value={(el.text && Array.isArray(el.text)) ? el.text : []}
                      prohibitEditing
                      className={s.constructor} />
                  </div>
                }
                {
                  el.type !== 'constructor' && <span>{i + 1}) <span key={i} className={s.capsuleRight}>{el.text}</span></span>
                }
              </>
            )
          })}
        </div>
      )
    }
    
    {props?.params?.result?.time_spent &&
      <div className={s.estimation}>
        <span className={s.boobleSpent}>Потрачено время</span>
        <span className={s.boobleSpent}> {formateTime(props?.params?.result?.time_spent)}</span>
      </div>
    }
    {video && <div style={{marginTop: '10px'}}><VideoAnswer video={video} videoType={videoType} /></div>}
  </div >
}

const Task = ({  params,hist, userRole, ...props }) => {
  const { onAnswer, answer, status, hint, video, videoType, correctAnswer } = useTaskHomeWork({...params, typeTask: 'pass-words'},  { ...props, type: 'arr' })

  const change = (state, index) => {
    const newList = [...answer.get]
    newList[index] = state
    answer.set(newList)
  }

  return <>
    <p className={classNames(s.text, s.textWrap)}>
      {props.answer_options?.map((el, i) => {
        const correctAnswer = props?.correct_answer[i];
        if (el.answer === 1) return (
          <Item 
            key={i} 
            type={el.type} 
            userRole={userRole} 
            status={status} 
            value={answer.get[i]} 
            change={e => change(e, i)} 
            correctAnswer={correctAnswer}
            {...el} />
        )
        return <Fragment key={i}>
            {
              el?.fromNewLine == '1' && (
                <div style={{width:'100%', height: '0'}}></div>
              )
            }
            <div className={s.itemWrapper}>
                <div className={s.questionWrapper}><JsonPars json={el.question} /></div>
            </div>
        </Fragment>
      })}
    </p>


    {!props?.hideSolutionCorrectness && correctAnswer &&  hist !== '?redo=ok' &&  params.type !== 'control' && <div className={s.answerWrapTask}>
      <span className={classNames(s.capsuleLeft)}>Правильные ответы</span>
      {correctAnswer?.map((el, i) => {
        return (
          <>
            {
              el.type === 'constructor' && <div style={{display: 'flex', gap: '5px'}}>
                {i + 1})
                <Constructor 
                  value={(el.text && Array.isArray(el.text)) ? el.text : []}
                  prohibitEditing
                  className={s.constructor} />
              </div>
            }
            {
              el.type !== 'constructor' && <span>{i + 1}) <span key={i} className={s.capsuleRight}>{el.text}</span></span>
            }
          </>
        )
      })}
    </div>}

    <AnswerButton hideSolutionCorrectness = {props?.hideSolutionCorrectness} hintForChild={params.hintForChild} hintAfterAllAttempts={props.hint_after_all_attempts} {...{ status, answer, onAnswer, hint, video, videoType }} />
  </>
}

const Item = ({ value, answer, change, type, allowed, status, state, userRole, correctAnswer, fromNewLine, ...props }) => {
  const answerText = !correctAnswer?.type ? correctAnswer?.text ?? '' : '';

  const constructorRef = useRef(null);
  
  let onChange = e => {
    const input = e.target
    const value = input.value;
    change({ text: value })
  }
  
  const onChangeConstructor = (value) => {
    change({ text: value })
    if (value.length > 3) {
      const width = constructorRef.current.clientWidth
      constructorRef.style.width = width + 'px'
    }
  }

  return <>
    {
        fromNewLine == '1' && (
          <div style={{width:'100%', height: '0'}}></div>
        )
    }
    
    <div className={s.itemWrapper}>
      <div className={s.questionWrapper}>
        <JsonPars json={props.question} />
      </div>
      {
        type === 'constructor' && (
          <div className={s.constructorWrapper} ref={constructorRef}>
            <Constructor 
              value={(value?.text && Array.isArray(value?.text)) ? value?.text : []}
              edit={(value) => onChangeConstructor(value)}
              prohibitEditing={(status > 4 || userRole === 'parent')}
              className={classNames(
                {[s.constructorCorrection]: (status > 4 || userRole === 'parent')}, 
                s.constructor,
                { [s.accent]: value && typeof value?.is_correct === 'boolean' && value?.is_correct }, 
                { [s.red]: value && typeof value?.is_correct === 'boolean' && !value?.is_correct }
              )} />
          </div>
        )
      }
        
      {
        type !== 'constructor' && (
          <span className={s.wrapper}>
            <DynamicInput
              targetWord={answerText}
              
              className={classNames(
                s.booble,
                s.input,
                { [s.accent]: typeof value?.is_correct === 'boolean' && value?.is_correct }, 
                { [s.red]: typeof value?.is_correct === 'boolean' && !value?.is_correct }
                // { [s.accent]: (status === 'chance' || !allowed) && state?.isRight },
                // { [s.red]: (status === 'chance' || !allowed) && !state?.isRight }
              )}
              value={value?.text ?? ''}
              disabled={status > 4 || userRole === 'parent'}
              placeholder='Напишите ответ'
              onInput={onChange}
            />
            <span className={s.booble}>Напишите ответ</span>
          </span>
        )
      }
        
    </div>
  </>
}
